<template>
  <div class="asset-list-container">
    <header>
      <h2>Anomaly Asset List</h2>
      <div class="search-filter-container">
        <div class="search-bar">
          <input
            type="text"
            v-model="searchTerm"
            placeholder="Enter device name or tag_mac"
          />
          <button @click="searchAssets">Search</button>
        </div>

        <!-- Radio Button Group -->
        <div class="filter-buttons">
          <label>
            <input type="radio" v-model="filter" value="all" @change="filterAssets" /> All Assets
          </label>
          <label>
            <input type="radio" v-model="filter" value="highTemp" @change="filterAssets" /> High Temperature
          </label>
          <label>
            <input type="radio" v-model="filter" value="lowTemp" @change="filterAssets" /> Low Temperature
          </label>
          <label>
            <input type="radio" v-model="filter" value="lowBattery" @change="filterAssets" /> Low Battery
          </label>
        </div>
      </div>
    </header>

    <table>
      <thead>
        <tr>
          <th @click="sortAssets('devicename')">Device Name <span :class="getArrowClass('devicename')"></span></th>
          <th>Image</th>
          <th @click="sortAssets('tag_mac')">Tag ID <span :class="getArrowClass('tag_mac')"></span></th>
          <th @click="sortAssets('devicetype')">Device Type <span :class="getArrowClass('devicetype')"></span></th>
          <th @click="sortAssets('tag_temperature')">Temp <span :class="getArrowClass('tag_temperature')"></span></th>
          <th @click="sortAssets('tag_vol')">Battery <span :class="getArrowClass('tag_vol')"></span></th>
          <th @click="sortAssets('tag_rssi')">RSSI <span :class="getArrowClass('tag_rssi')"></span></th>
          <th @click="sortAssets('building')">Building <span :class="getArrowClass('building')"></span></th>
          <th @click="sortAssets('floor')">Floor <span :class="getArrowClass('floor')"></span></th>
          <th @click="sortAssets('taglocation')">Last Scanned Zone <span :class="getArrowClass('taglocation')"></span></th>
          <th @click="sortAssets('assignedzone')">Assigned Zone <span :class="getArrowClass('assignedzone')"></span></th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="filteredAssets.length === 0">
          <td colspan="12">No assets found matching your search.</td>
        </tr>
        <tr v-else v-for="(asset, index) in filteredAssets" :key="index">
          <td>{{ asset.devicename }}</td>
          <td><img :src="getAssetImage(asset.imagepath)" alt="Asset Image" class="table-image" /></td>
          <td>{{ asset.tag_mac }}</td>
          <td>{{ asset.devicetype }}</td>
          <td>
            <span class="material-symbols-outlined thermostat" style="font-size: 16px;">device_thermostat</span>
            <span>{{ asset.tag_temperature }} °C</span>
          </td>
          <td>
            <span :class="getBatteryStatus(asset.tag_vol)">
              {{ asset.tag_vol >= 2.7 ? 'Good' : asset.tag_vol >= 2.3 ? 'Mid' : 'None' }}
            </span>
            <span class="battery-value"> ({{ asset.tag_vol.toFixed(1) }}v)</span>
          </td>
          <td>
            <span v-if="Math.abs(asset.tag_rssi) <= 70">
              <span class="material-symbols-outlined rssi-good" style="font-size: 24px;">signal_cellular_alt</span>
            </span>
            <span v-else>
              <span class="material-symbols-outlined rssi-mid" style="font-size: 24px;">signal_cellular_alt_2_bar</span>
            </span>
          </td>
          <td>{{ asset.building }}</td>
          <td>{{ asset.floor }}</td>
          <td>{{ asset.taglocation }}</td>
          <td>{{ asset.assignedzone }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      searchTerm: '',
      assets: [],
      filteredAssets: [],
      filter: 'all', // 초기 필터 설정
      sortKey: 'tag_mac',
      sortOrder: 1,
    };
  },
  created() {
    this.setFilterFromQuery();
    this.loadAssetList();
    console.log("Current filter in loadAssetList:", this.filter);
  },
  methods: {
    loadAssetList() {
      const company = localStorage.getItem('company');
      console.log('company :', company);
      axios
        .get('/api/assetList', {
          params: {
            search: this.searchTerm,
            filter: this.filter,
            company: company,
          },
        })
        .then((response) => {
          this.assets = response.data;
          console.log('this.assets :', this.assets);
          console.log('response.data :', response.data);
          this.filterAssets(); // 데이터 로딩 후 필터링
        })
        .catch((error) => {
          console.error('Error fetching assets:', error);
        });
    },
    filterAssets() {
      this.filteredAssets = this.assets.filter(asset => asset.devicename !== null);
      // this.filteredAssets = this.assets.filter(asset => asset.devicename !== null);

      // 필터에 따라 필터링
      if (this.filter === 'all') {
        this.filteredAssets = this.assets;
      } else {
        this.filteredAssets = this.assets.filter(asset =>
          asset.categories && asset.categories.includes(this.filter) // categories가 존재하는지 확인
        );
      }
      
      // else if (this.filter === 'highTemp' || 'highTemp','lowBattery') {
      //   this.filteredAssets = this.assets.filter(asset => asset.category === 'highTemp');
      // } else if (this.filter === 'lowTemp'|| 'lowTemp','lowBattery') {
      //   this.filteredAssets = this.assets.filter(asset => asset.category === 'lowTemp');
      // } else if (this.filter === 'lowBattery'|| 'highTemp','lowBattery'|| 'lowTemp','lowBattery') {
      //   this.filteredAssets = this.assets.filter(asset => asset.category === 'lowBattery');
      // }
      
      this.sortAssets(this.sortKey, true); // 필터링 후 정렬 유지
    },
    searchAssets() {
      this.loadAssetList(); // 검색을 위해 서버에 요청하고 결과를 가져옴
    },
    getAssetImage(imagePath) {
      if (!imagePath) {
        return require('@/assets/inventory.png'); // 기본 이미지 파일 경로
      }
      try {
        return require(`@/assets/${imagePath}`);
      } catch (error) {
        console.error('Image not found:', error);
        return require('@/assets/inventory.png'); // 기본 이미지 경로
      }
    },
    getBatteryStatus(voltage) {
      if (voltage >= 2.7) {
        return 'battery_good'; // 정상
      } else if (voltage >= 2.3 && voltage < 2.7) {
        return 'battery_mid'; // 중간
      } else {
        return 'battery_none'; // 낮음
      }
    },
    sortAssets(key, keepOrder = false) {
      if (!keepOrder) {
        this.sortOrder = this.sortKey === key ? -this.sortOrder : 1;
      }
      this.sortKey = key;
      this.filteredAssets.sort((a, b) => {
        if (a[key] < b[key]) return -1 * this.sortOrder;
        if (a[key] > b[key]) return 1 * this.sortOrder;
        return 0;
      });
    },
    getArrowClass(key) {
      if (this.sortKey === key) {
        return this.sortOrder === 1 ? 'arrow-up' : 'arrow-down';
      }
      return 'arrow-default';
    },
    setFilterFromQuery() {
      const query = this.$route.query.filter; // URL 쿼리에서 필터 값 가져오기
      if (query) {
        this.filter = query; // 필터 상태 업데이트
      }
    },
  },
};
</script>

<style scoped>
.asset-list-container {
  padding: 20px;
}

header {
  margin-bottom: 20px;
}

.search-filter-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.search-bar {
  display: flex;
}

.search-bar input[type="text"] {
  padding: 10px;
  width: 250px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.search-bar button {
  padding: 10px;
  border: none;
  background-color: #007bff;
  color: white;
  border-radius: 5px;
  cursor: pointer;
}

.search-bar button:hover {
  background-color: #0056b3;
}

.filter-buttons {
  display: flex;
  gap: 10px;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

thead th {
  background-color: #f0f0f0;
  padding: 10px;
  text-align: left;
  cursor: pointer;
  position: relative;
}

tbody td {
  padding: 10px;
  border-bottom: 1px solid #ddd;
}

tbody img {
  border-radius: 4px;
}
table img {
  width: 40px; /* 고정 너비 */
  height: 60px; /* 고정 높이 */
  object-fit: contain; /* 비율 유지 */
}
.battery_good {
  color: green;
  font-weight: bold;
}

.battery_mid {
  color: orange;
  font-weight: bold;
}

.battery_none {
  color: skyblue;
  font-weight: bold;
}

.rssi-good {
  color: green;
}

.rssi-mid {
  color: orange;
}

.rssi-low {
  color: red;
}

.thermostat {
  color: red;
}

.battery-value {
  color: black;
}
</style>
